<div 
  class="filter-control"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
  (click)="toggle()">
  @if(icono){
    <mat-icon class="icono">
      {{icono}}
    </mat-icon>
  }

  <div class="title">
    {{config.title}}
  </div>

  <div class="value">
      @for (value of displayValue; track $index) {
        <div class="chip" [matTooltip]="value" [appOverflowTooltip]="value">
          {{value}}
        </div>
      }

    <mat-icon>
        {{open?'expand_less':'expand_more'}}
    </mat-icon>
  </div>
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="open"
  [cdkConnectedOverlayHasBackdrop]="true"
  [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-background'"
  [cdkConnectedOverlayPositions]="positions"
  (backdropClick)="close()">
  <app-filter-overlay [config]="config" (selected)="selection($event)"/>
</ng-template>